import type { ChecklistItem } from '../../config/documentChecklists';
import { REQUIREMENT_TO_SECTION_MAP } from '../../config/requirementToSection';
import type { ExtractedClaim } from '../../types/siteContext';
import type { ProjectIntent } from '../../types/siteRag';
import type { SiteEvidenceDocument } from '../../types/siteEvidence';
import { getAlignedFieldPaths } from './requirementFieldAlignment';
import { resolveReportFields } from './resolveReportFields';
import { evidenceRequirementForStage, evidenceResolvedFieldsForStage, type EvidenceDecisionStage } from './stageEvidenceFields';

/** Source inspection follows the same stage-visible facts as the worksheet. */
export function evidenceSourceScope(input: {
  requirement: ChecklistItem;
  stage?: EvidenceDecisionStage;
  sed?: SiteEvidenceDocument;
  projectIntent?: ProjectIntent;
  authoredClaim?: ExtractedClaim;
}): { fieldPaths: string[]; sectionIds: string[] } {
  const { requirement, stage } = input;
  if (!evidenceRequirementForStage(requirement, stage, input.projectIntent)) return { fieldPaths: [], sectionIds: [] };
  const fields = evidenceResolvedFieldsForStage(resolveReportFields(input), requirement.id, stage);
  const primarySection = REQUIREMENT_TO_SECTION_MAP[requirement.id]?.[0];
  const paths = new Set(fields.related.map(field => field.path));
  for (const field of fields.primary) {
    if (field.key === 'notes') continue;
    for (const path of getAlignedFieldPaths(requirement.id, field.key)) paths.add(path);
    // Document-only values and source conflicts are stamped by schema key.
    if (primarySection) paths.add(`${primarySection}.${field.key}`);
  }
  const fieldPaths = [...paths];
  return { fieldPaths, sectionIds: [...new Set(fieldPaths.map(path => path.split('.')[0]!))] };
}
